import React from 'react';
import { FadeIn } from './FadeIn';
export function FinalCTA() {
  return <section className="py-12 bg-surface border-t border-white/5 relative overflow-hidden" aria-label="Llamada final a la acción" data-id="element-40">
      <div className="container mx-auto px-4 max-w-4xl relative z-10 text-center" data-id="element-41">
        <FadeIn data-id="element-42">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-2" data-id="element-43">
            Última oportunidad —{' '}
            <span className="text-gold" data-id="element-44">elegí tu pack</span>
          </h2>
          <p className="text-gray-400 mb-10" data-id="element-45">
            🛡️ Garantía 7 días · ⚡ Acceso de inmediato · 🔒 Pago seguro
          </p>
        </FadeIn>

        {/* Pack 1 — Base (anclaje, arriba) */}
        <FadeIn delay={0.1} data-id="element-46">
          <a href="https://fegion.shop/cart/46850728263819:1" className="flex flex-col sm:flex-row items-center sm:items-stretch justify-between gap-4 p-5 md:p-6 bg-surfaceLight border border-white/10 rounded-2xl hover:border-white/30 transition-colors text-left mb-5 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold" aria-label="Comprar Sistema Maestro de Aluminio por $17.990 ARS" data-id="element-47">
            <div className="flex-1" data-id="element-48">
              <span className="block text-base md:text-lg font-bold text-white mb-1" data-id="element-49">
                📘 SISTEMA MAESTRO + 4 BONOS
              </span>
              <span className="block text-xs md:text-sm text-gray-400" data-id="element-50">
                Para empezar con sistema · 6 Tomos + 4 Bonos
              </span>
            </div>
            <div className="flex items-center gap-4 shrink-0" data-id="element-51">
              <div className="flex flex-col items-end" data-id="element-52">
                <span aria-hidden="true" className="text-gray-500 line-through text-xs" data-id="element-53">
                  $45.000
                </span>
                <span className="text-xl md:text-2xl font-bold text-white" data-id="element-54">
                  $17.990
                </span>
              </div>
              <div className="py-2.5 px-4 rounded-xl font-bold text-white border border-white/20 uppercase tracking-wider text-[11px] whitespace-nowrap" data-id="element-55">
                Lo quiero
              </div>
            </div>
          </a>
        </FadeIn>

        {/* Pack 2 — Pro (DOMINANTE, en el medio — el más elegido) */}
        <FadeIn delay={0.2} data-id="element-56">
          <div className="relative my-6" data-id="element-57">
            {/* Glow exterior dorado */}
            <div className="absolute -inset-1 rounded-3xl opacity-70 blur-md pointer-events-none" aria-hidden="true" style={{
            background: 'linear-gradient(135deg, rgba(212,168,67,0.5) 0%, rgba(245,200,80,0.5) 100%)'
          }} data-id="element-58"></div>
            <a href="https://fegion.shop/cart/46850730492043:1" className="relative flex flex-col md:flex-row items-center md:items-stretch justify-between gap-5 p-7 md:p-8 bg-gold rounded-3xl hover:bg-gold/90 transition-colors shadow-[0_0_35px_rgba(212,168,67,0.25)] focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold" aria-label="Comprar Sistema Maestro + Fichas de Taller por $23.990 ARS" data-id="element-59">
              <span className="absolute -top-3 left-1/2 -translate-x-1/2 bg-background text-gold border border-gold/40 font-bold px-5 py-1.5 rounded-full text-[11px] uppercase tracking-wider whitespace-nowrap shadow-lg" data-id="element-60">
                ⭐ EL MÁS ELEGIDO — TALLER AUTÓNOMO
              </span>

              <div className="flex-1 text-left md:pr-4 flex flex-col justify-center mt-3 md:mt-0" data-id="element-61">
                <span className="block text-lg md:text-xl font-bold text-background mb-1" data-id="element-62">
                  🏆 SISTEMA MAESTRO + FICHAS DE TALLER
                </span>
                <span className="block text-sm text-background/90 mb-1 font-medium" data-id="element-63">
                  Sistema Maestro + 4 Bonos + Fichas de obra
                </span>
                <span className="block text-xs text-background/70" data-id="element-64">
                  Ideal para talleres que quieren delegar y que el ayudante
                  trabaje solo.
                </span>
              </div>

              <div className="flex flex-col items-center md:items-end justify-center shrink-0" data-id="element-65">
                <span aria-hidden="true" className="text-background/60 line-through text-sm" data-id="element-66">
                  $55.000 ARS
                </span>
                <span className="text-4xl md:text-5xl font-bold text-background font-heading leading-none" data-id="element-67">
                  $23.990
                </span>
                <span className="text-xs text-background/80 mt-1" data-id="element-68">ARS</span>
              </div>

              <div className="hidden md:flex items-center shrink-0" data-id="element-69">
                <div className="py-4 px-6 rounded-xl font-bold text-gold bg-background hover:bg-background/90 transition-colors uppercase tracking-wider text-sm text-center whitespace-nowrap" data-id="element-70">
                  → Quiero el pack pro
                </div>
              </div>
              <div className="w-full md:hidden mt-2" data-id="element-71">
                <div className="w-full py-3 px-4 rounded-xl font-bold text-gold bg-background hover:bg-background/90 transition-colors uppercase tracking-wider text-xs text-center" data-id="element-72">
                  → Quiero el pack pro
                </div>
              </div>
            </a>
          </div>
        </FadeIn>

        {/* Pack 3 — Total (línea premium, abajo) */}
        <FadeIn delay={0.3} data-id="element-73">
          <div className="relative mt-6 mb-10" data-id="element-74">
            <span className="absolute -top-3 left-1/2 -translate-x-1/2 bg-blue-500 text-white font-bold px-4 py-1 rounded-full text-[10px] uppercase tracking-wider whitespace-nowrap shadow-lg z-10" data-id="element-75">
              🔥 LA VERSIÓN MÁS COMPLETA 💎
            </span>
            <a href="https://fegion.shop/cart/46934190555275:1" className="relative flex flex-col sm:flex-row items-center sm:items-stretch justify-between gap-4 p-5 md:p-6 bg-surfaceLight border-2 border-blue-500/40 rounded-2xl hover:border-blue-400/70 transition-colors text-left focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-400" aria-label="Comprar Sistema Maestro Pro por $29.990 ARS" data-id="element-76">
              <div className="flex-1 mt-2 sm:mt-0" data-id="element-77">
                <span className="block text-base md:text-lg font-bold text-white mb-1" data-id="element-78">
                  💎 SISTEMA MAESTRO PRO
                </span>
                <span className="block text-xs md:text-sm text-blue-300/90" data-id="element-79">
                  Todo + A30 Master + Módulo Técnico Premium (HA62 + Rotonda)
                </span>
              </div>
              <div className="flex items-center gap-4 shrink-0" data-id="element-80">
                <div className="flex flex-col items-end" data-id="element-81">
                  <span aria-hidden="true" className="text-gray-500 line-through text-xs" data-id="element-82">
                    $85.000
                  </span>
                  <span className="text-xl md:text-2xl font-bold text-blue-300" data-id="element-83">
                    $29.990
                  </span>
                </div>
                <div className="py-2.5 px-4 rounded-xl font-bold text-white bg-blue-500 hover:bg-blue-600 transition-colors uppercase tracking-wider text-[11px] whitespace-nowrap" data-id="element-84">
                  Lo quiero
                </div>
              </div>
            </a>
          </div>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-85">
          <div className="flex flex-wrap justify-center items-center gap-x-6 gap-y-3 text-sm text-gray-400" data-id="element-86">
            <div className="flex items-center gap-2" data-id="element-87">
              <span className="text-green-400" aria-hidden="true" data-id="element-88">
                🛡️
              </span>
              <span data-id="element-89">Garantía 7 días</span>
            </div>
            <span className="text-white/10" aria-hidden="true" data-id="element-90">
              ·
            </span>
            <div className="flex items-center gap-2" data-id="element-91">
              <span className="text-green-400" aria-hidden="true" data-id="element-92">
                ⚡
              </span>
              <span data-id="element-93">Acceso de inmediato</span>
            </div>
            <span className="text-white/10" aria-hidden="true" data-id="element-94">
              ·
            </span>
            <div className="flex items-center gap-2" data-id="element-95">
              <span className="text-green-400" aria-hidden="true" data-id="element-96">
                🔒
              </span>
              <span data-id="element-97">Pago 100% seguro</span>
            </div>
            <span className="text-white/10" aria-hidden="true" data-id="element-98">
              ·
            </span>
            <div className="flex items-center gap-2" data-id="element-99">
              <span className="text-green-400" aria-hidden="true" data-id="element-100">
                💳
              </span>
              <span data-id="element-101">Mercado Pago | Tarjeta | Transferencia</span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}